import { render, staticRenderFns } from "./userManage.vue?vue&type=template&id=0caf404c&"
import script from "./userManage.vue?vue&type=script&lang=js&"
export * from "./userManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports